import { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

// selectors
import { selectIsSearchifySubmittable } from "shared/search/searchify/selectors"
import { selectSearchTerm } from "app/static/frontend/search-new/selectors"
import { setSearchTerm } from "app/static/frontend/search-new/action-creators"

// helpers
import { delay } from "shared/imports/sharedHelperFunctions"

const mapStateToProps = (state, props) => ({
    searchTerm: selectSearchTerm(state),
    isSearchify: selectIsSearchifySubmittable(state, props),
})

const actions = {
    setSearchTerm,
}

/*
    This component brings the search term from the search bar into our
    current FLV so the filters can work accordingly. The logic will influence
    components/SearchBar/SearchBar.js.
*/
export class SearchBarFilter extends Component {
    static propTypes = {
        deserializedValue: PropTypes.string,
        publishChange: PropTypes.func.isRequired,
        // from connect
        searchTerm: PropTypes.string,
        setSearchTerm: PropTypes.func.isRequired,
        isSearchify: PropTypes.bool,
    }

    async componentDidMount() {
        // thunk delay to allow selectSearchTerm to actually select the new undefined searchTerm
        // from app/static/frontend/search-new/components/FilterableListView/index.js this.props.setSearchTerm(undefined)
        // after the component unmounts (i.e., when we go from Search to Searchify or vice-versa)

        // without this immediate delay, the component remounts before reselect can recompute the new searchTerm value,
        // which means that segueing back to Search from Searchify (Power Search) will erroneously apply the previous Power Search
        // searchTerm to primary Search

        // see shared/profiles/event/event-profile-action-creators resetTranscriptsState
        // for a similar redux-thunk action-creator implementation
        await delay(0)

        if (!this.props.searchTerm && this.props.deserializedValue) {
            // if there's no search term but we have an filter value, set the search term!
            // (this will happen in the cases of segueing back from searchify)
            // NOTE: this will not work unless we add the immediate delay thunk above
            this.props.setSearchTerm(this.props.deserializedValue)
        } else {
            // make sure we fire the search in each dataset on segue
            if (this.props.searchTerm && !this.props.isSearchify) {
                this.props.setSearchTerm(this.props.searchTerm)
                this.props.publishChange(this.props.searchTerm)
            }
        }
    }

    async componentDidUpdate(prevProps) {
        await delay(0)

        if (prevProps.searchTerm !== this.props.searchTerm) {
            this.props.setSearchTerm(this.props.searchTerm)
            this.props.publishChange(this.props.searchTerm)
        }
    }

    render() {
        return null
    }
}

export default connect(mapStateToProps, actions)(SearchBarFilter)
